import React, { useEffect } from 'react';
import FullPageCarousel from '../Components/Carousel/FullPageCarousel';
import ImageCard from '../Components/ImageCard/ImageCard';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './PageCss/HomePage.css';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import CenterStage from '../Components/CenterStage/CenterStage';
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery hook


import imgHose from '../assets/hose.jpg';
import imgCarton from '../assets/Hansa-Flex_Kartons_Shop.png';

import Promoter from '../Components/Promoter/Promoter';
import FeatureCardCarousel from '../Components/FeaturesCardCarousal/FeatureCardCarousal'
import AOS from 'aos';
import 'aos/dist/aos.css';
import circleCheck from '../assets/check-circle.svg'
import imgIndustriesServedThaith from '../assets/IndustriesServedThaith.png'
import imgIndustriesServedEnglish from '../assets/Industries.jpg'
import Horizontal from '../Components/Horizontal/Horizontal';
import imgThPrHydrauliclhose from '../assets/ThPrHydrauliclhose.jpg';
import imgThPrMetalhose from '../assets/ThPrMetalhose.jpg'

import imgThSrInstallation from '../assets/ThSrInstallation.jpg'
import imgThSrMobileService from '../assets/ThSrMobileService.jpg'
import imgThSrCylinderrepair from '../assets/ThSrCylinderrepair.jpg'
import imgThSrOilfiter from '../assets/ThSrOilfiter.jpg'
import imgThSrTraining from '../assets/ThSrTraining.jpg'
import imgThSrOnsiteinstallation from '../assets/ThSrOnsiteinstallation.jpg'
import { useTranslation } from 'react-i18next';



function HomePage() {
  const { i18n, t } = useTranslation();
  var imgIndustries = imgIndustriesServedThaith;
  if (i18n.language === 'en') {
    imgIndustries = imgIndustriesServedEnglish;
  }

  const isLaptop = useMediaQuery({ minWidth: 1024 }); // Define the breakpoint for laptop screen size
  const isMobile = window.innerWidth <= 768;


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);


  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 320, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 300, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  const featuresData = [
    {
      title: "Extensive Spare Parts Inventory",
      description: "Maintaining a stock of 8,000+ spare parts and offering 10,000 more overnight to minimize customer downtime.",
      image: circleCheck
    },
    {
      title: "Technical Consultation Services",
      description: "Offering expert advice on system design, optimization, maintenance, and spare parts procurement for efficient, uninterrupted operations.",
      image: circleCheck
    },
    {
      title: "Global Accessibility",
      description: "With a global network of subsidiaries, HANSA-FLEX Thailand ensures customers receive individualized, fast, and reliable service worldwide.",
      image: circleCheck
    },



    // Add more objects for additional FeaturesCard data
  ];

  //promoter content

  const promoterTitle = 'PLACE YOUR ORDER TODAY!';
  const promoterChecklistItems = [
    'The full HANSA-FLEX product range with more than 80,000 articles.',
    'Category-specific filter parameters enable quick navigation.',
    'Please call us for availability.'
  ];
  const promoterButtonLabels = ['CONTACT US', 'FIND OUT MORE !'];

  const googleReviewsLink = "https://www.google.com/search?q=HANSA-FLEX+Hydraulics+Middle+East+Electromechanical+Works+L.L.C.%0D%0A&sca_esv=5fc86f3f882bb04d&rlz=1C1GCEU_enIN1077IN1077&sxsrf=ADLYWIL4idna669YeckDiMTYuKLOHzGRjg%3A1717400752112&ei=sHRdZqG-BsnV4-EPnvyZmQc&ved=0ahUKEwih1pCu-L6GAxXJ6jgGHR5-JnMQ4dUDCBA&uact=5&oq=HANSA-FLEX+Hydraulics+Middle+East+Electromechanical+Works+L.L.C.%0D%0A&gs_lp=Egxnd3Mtd2l6LXNlcnAiQUhBTlNBLUZMRVggSHlkcmF1bGljcyBNaWRkbGUgRWFzdCBFbGVjdHJvbWVjaGFuaWNhbCBXb3JrcyBMLkwuQy4KMgcQIxiwAxgnMgcQIxiwAxgnMgcQIxiwAxgnMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHMgoQABiwAxjWBBhHSKwNUIgIWIgIcAN4AZABAJgBAKABAKoBALgBA8gBAPgBAvgBAZgCA6ACFZgDAIgGAZAGCpIHATOgBwA&sclient=gws-wiz-serp#lrd=0x3e5f6bdae190b3cf:0x98b7ff27fa3849e,1";

  return (
    <div>
      <FullPageCarousel />

      <SectionHeader
        title="Our Products"
      />
      <Container className="custom-container">
        <Row>
          <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThPrHydrauliclhose} learnMoreLink="/hydraulic-hoses" title="HYDRAULIC HOSE" desc="Hydraulic Hose Hydraulic Hose is like a blood vessel that nourishes hydraulic oil to various parts that are like organs in the machine. For hydraulic hoses, it is designed to be used..." />
          </Col>
          <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-left"}>
            <ImageCard image={imgThPrMetalhose} learnMoreLink="/pipe-fitting" title="METAL HOSE" desc="Transitions between components in hydraulic systems are always a point for careful consideration. Pipe fittings from HANSA-FLEX are standardised in accordance with DIN EN ISO 8434-1 and DIN 2353...." />
          </Col>
          {/* <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-left"}>
            <ImageCard image={imgHomeBelgium_Adaptar} learnMoreLink="/adapters" title="ADAPTERS" desc="Adapters create a safe and leak-free connection between components with differing thread types.HANSA-FLEX offers an extensive portfolio of hydraulic adapters, such as threaded or transition adapters in all common connection....." />
          </Col>
          <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgHomeBelgium_INDHOSES} learnMoreLink="/Industrial-hoses" title="SYSTEM PARTNER FOR INDUSTRIAL HOSES" desc="Industrial hoses find application where the medium is not used to transmit energy. Industrial hoses transport a wide variety of media, from water and air to chemicals, fuels, and gases, in almost every industry sector. In its hose specialist workshop, HANSA-FLEX meets customer requirements with the highest quality standards and shortest delivery times. In the HANSA-FLEX online shop, you will find a wide range of industrial hoses." />
          </Col>
          <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgHomeBelgium_Cylinder} learnMoreLink="/cylinder" title="CYLINDERS" desc="Hydraulic cylinders perform extremely heavy work. As the most important drive elements in hydraulics, they convert the pressure energy of the hydraulic fluid into mechanical energy..." />
          </Col>
          <Col sm={12} md={6} lg={6} data-aos={isMobile ? "fade-up" : "fade-left"}>
            <ImageCard image={imgHomeBelgium_driveandcontroltechnology} learnMoreLink="/drive-and-control-tech" title="DRIVE AND CONTROL TECHNOLOGY" desc="Hydraulic components fulfil the highest quality standards at HANSA-FLEX, where quality management has DIN ISO 9001 certification. Availability is ensured by our warehouse, which stocks over 4,500 hydraulic components." />
          </Col> */}

        </Row>
      </Container>

      <SectionHeader
        title="Our Services"
      />
      <Container className="custom-container">
        <Row>
          <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThSrInstallation} learnMoreLink="/installation-of-pipe-and-hoseline-systems" title="INSTALL HOSE PIPE" desc="The pipes and hoses of hydraulic machines and systems must be replaced regularly for safety reasons alone…" />
          </Col>
          <Col sm={12} md={6} lg={8} data-aos={isMobile ? "fade-up" : "fade-left"}>
            <ImageCard image={imgThSrMobileService} learnMoreLink="/mobile-rapid-hydraulic-service" title="MOBILE SERVICE VEHICLE" desc="Mobile service vehicles are available 24 hours a day, every day…" />
          </Col>
          <Col sm={12} md={6} lg={8} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThSrCylinderrepair} learnMoreLink="/hydraulic-cyclinder-repair" title="REPAIR HYDRAULIC CYLINDER" desc="HANSA-FLEX inspects your industrial hose lines in accordance with the German Industrial Safety Act (BetrSichV). We perform inspections as an on-site service from our mobile inspection service vehicles or in our centres..." />
          </Col>
          <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThSrOilfiter} learnMoreLink="/oil-filtering-and-cleaning" title="OIL FILTER" desc="Hydraulic cylinders are subject to extreme stresses due to their continual extending and retracting. The result is wear, which puts the whole working process at risk of failure. Overhauling a cylinder is..." />
          </Col>
          <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThSrTraining} learnMoreLink="/hydraulic-academy" title="PROVIDE TRAINING FOR CUSTOMERS" desc="Training is the best way to counteract the shortage of qualified personnel. HANSA-FLEX utilizes the active transfer of knowledge from experienced experts to trainees, employees, and clients." />
          </Col>
          <Col sm={12} md={6} lg={8} data-aos={isMobile ? "fade-up" : "fade-right"}>
            <ImageCard image={imgThSrOnsiteinstallation} learnMoreLink="/assembly-and-installation" title="ON-SITE INSTALLATION" desc="Retrofitting or renovating a hydraulic system can often be an effective alternative to purchasing a new one. It is also a way to raise energy efficiency and productivity or comply with new..." />
          </Col>

        </Row>
      </Container>



      {/* <div>
        <SectionHeader
          title="Our Services"
        /> */}
      {/* 
        <Container className="custom-container">
          <Row> */}




      {/* </Row>
        </Container>


      </div> */}


      {/* <div>
        <SectionHeader
          title="Explore our units!"
          paragraph="We have our units in Pune, which provide extensive range of products!"
        />
        <ShowcaseCarousel carouselItems={carouselItems} descDisplay={isMobile ? 'none' : 'block'} />
      </div>
      <br /><br /><br /> */}

      <div className='div-gray center-all-items'>
        <SectionHeader
          title="Premium Hydraulics & Pneumatics Solutions"
          subtitle="Select from more than 80,000 articles and always find the right product for your needs. We stock everything from A-Z."
        />
        <FeatureCardCarousel featuresData={featuresData} />
      </div>


      <div>
        {isLaptop && (
          <Promoter
            title={promoterTitle}
            checklistItems={promoterChecklistItems}
            btnLabel1={"Find Out More !"}
            btnLabel1Link={"/hoses-and-hose-lines"}
            imageUrl={imgCarton}
          />
          // TODO: contact us button
        )}
      </div>


      {/* <div>
        <SectionHeader
          title="News and Events" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={8} data-aos="fade-up" ><ImageCard image={imgIree} learnMoreLink={'/iree'} title="HANSA-FLEX at IREE" desc={"HANSA-FLEX India is thrilled to have participated in the 15th edition of the International Railway Equipment Exhibition (IREE), which took place from October 12 to 14, 2023, at Pragati Maidan, New Delhi. IREE stands as Asia's largest platform dedicated to the Rail Transportation Sector, and this event was organized by the Confederation of Indian Industry (CII) in collaboration with the Ministry of Railways, Government of India."} /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgBauma} learnMoreLink={'/bauma'} title="Bauma Conexpo India 2023 " desc="The 6th edition of international trade fair Bauma Conexpo India 2023, construction machinery event was held in Greater Noida, from Jan 31st -3rd Feb, 2023. " /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgTree} learnMoreLink={'/tree-plantation'} title="Tree Plantation on Environment Day" desc="HANSA-FLEX India Pvt Ltd proudly celebrates Environment Day by organizing a tree plantation event, acknowledging the importance of environmental conservation and sustainability. The event is scheduled to take place on the 5th of June 2023, from 9:00 am to 11:00 am" /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgGarry} learnMoreLink={'/product-training'} title="Product training session taken by Gary Howes" desc="Join us for an extensive training session on Hose Assembly, Fittings, and Welding Products presented by Gary Howes. Taking place from the 4th to the 14th of July 2023 at HANSA-FLEX (IFP) INDIA PVT LTD, this comprehensive training program will cover a wide range of topics essential for professionals in the industry." /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgGoetheVisit} learnMoreLink={'/goethe-event'} title="Empowering Students: Insights into Career Opportunities and Language Skills" desc="Join us for an extensive training session on Hose Assembly, Fittings, and Welding Products presented by Gary Howes. Taking place from the 4th to the 14th of July 2023 at HANSA-FLEX (IFP) INDIA PVT LTD, this comprehensive training program will cover a wide range of topics essential for professionals in the industry." /></Col>
          </Row>
        </Container>
      </div> */}


      <div>
        <SectionHeader title={"Industries Served"} />
        <div className="home-imageContainer">
          {isMobile ? <>
            <img src={imgIndustries} alt="Description of the image" className='home-img' />

          </> : <>
            <img src={imgIndustries} alt="Description of the image" className='home-img' />

          </>}
        </div>
      </div>
      <br />
      <br />
      <br />


      {/* <div className="text-center div-white">
        <SectionHeader
          title={"Check out our reviews on google!"}
          paragraph={"Curious about what others have to say about us? Take a moment to explore our Google reviews and discover why our customers rave about their experiences with us. "} />
        <br />
        <Button variant="primary" href={googleReviewsLink} target="_blank" className="btn-google" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>View our reviews on Google</Button>
      </div> */}

      <br />
      <br />
      {/* <br /><br /> */}

      <div>
        <Horizontal />
      </div>
    </div>

  );
}

export default HomePage;
